import { render, staticRenderFns } from "./deletePurchaseApply.vue?vue&type=template&id=72094f68&scoped=true"
import script from "./deletePurchaseApply.vue?vue&type=script&lang=js"
export * from "./deletePurchaseApply.vue?vue&type=script&lang=js"
import style0 from "./deletePurchaseApply.vue?vue&type=style&index=0&id=72094f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72094f68",
  null
  
)

export default component.exports